import React from 'react';
 
 
 import {
     Button,   
     DatePicker,  
     Input,
     ColumnLayout,
     RadioGroup,
     Select,
     Table,
     TablePagination,
     TableSorting,
     Textarea,
     TimeInput,
     Modal,
     Spinner
 
 } from 'AWS-UI-Components-React';
 
 import {
     JSClient,
     Header
 } from './common';
 
const FILTER_TYPES = [
     {
       "label": "Any",
       "value": "Any",
       "description": "At least one filter must be satisfied for the event to be included"
     },
     {
       "label": "All",
       "value": "All",
       "description": "All the filters must match for the event to be included"
     }
 ]
 
const CATEGORIES = [
     {
        "label": "Access Keys",
        "id": "accessKeys"          
     },
     {
        "label": "AMIs",
        "id": "amis"
     },
     {
        "label": "Instance Types",
        "id": "instanceTypes"
     },
     {
        "label": "IP Address",
        "id": "ipAddresses"
     },
     {
        "label": "Regions",
        "id": "regions"
     },
     {
        "label": "User Agent",
        "id": "userAgents"
     }
 ]
 
function createColumnFilters(callback) {
 const COLUMN_DEFINITIONS_FILTERS = [
     {
         id: 'user_agent',
         header: () => 'User Agent',
         cell: (item) => {
            if(item.user_agent) { 
                return item.user_agent.map(item => <li>{item} <Button variant="icon" icon="add-plus"
            onClick={() => callback('user_agent', item)}></Button></li>) 
            }},
         minWidth: '125px',
         allowLineWrap: false
     },
     {
         id: 'req_n_inst',
         header: () => '# of Instances Requested',
         cell: (item) => {
            if (item.req_n_inst) {
                return item.req_n_inst.map(item => <li>{item}</li>)
            }},
         minWidth: '25px',
         allowLineWrap: false
     },
     {
         id: 'n_inst',
         header: () => '# of Instances Launched',
         cell: (item) => {
            if (item.n_inst) {
                return item.n_inst.map(item => <li>{item}</li>)
            }},
         minWidth: '25px',
         allowLineWrap: false
     },
     {
         id: 'req_norm_inst',
         header: () => '# of Normalized Instances Requested',
         cell: (item) => {
            if (item.req_norm_inst) {
                return item.req_norm_inst.map(item => <li>{item}</li>)
            }},
         minWidth: '25px',
         allowLineWrap: false
     },
     {
         id: 'norm_inst',
         header: () => '# of Normalized Instances Launched',
         cell: (item) => {
            if (item.norm_inst) {
                return item.norm_inst.map(item => <li>{item}</li>)
            }},
         minWidth: '25px',
         allowLineWrap: false
     },
     {
         id: 'access_key',
         header: () => 'Access Keys',
         cell: (item) => {
            if (item.access_key) {
                return item.access_key.map(item => <li><a href={`https://github.com/search?q={item}&type=Code`} target="_blank">{item}</a>
            <Button variant="icon" icon="add-plus" onClick={() => callback('access_key', item)}></Button></li>)
            }},
         minWidth: '100px',
         allowLineWrap: false
     },
     {
         id: 'region',
         header: () => 'Regions',
         cell: (item) => {
            if (item.region) {
                return item.region.map(item => <li>{item}</li>)
            }},
         minWidth: '125px',
         allowLineWrap: false
     },
     {
         id: 'instance_type',
         header: () => 'Instance Types',
         cell: (item) => {
            if (item.instance_type) {
                return item.instance_type.map(item => <li>{item}</li>)
            }},
         minWidth: '75px',
         allowLineWrap: false
     },
     {
         id: 'ip_address',
         header: () => 'IP Addresses',
         cell: (item) => {
            if (item.ip_address) {
                return item.ip_address.map(item => <li>{item}</li>)
            }},
         minWidth: '75px',
         allowLineWrap: false
     },
     {
         id: 'ami_id',
         header: () => 'AMIs',
         cell: (item) => {
            if (item.ami_id) {
                return item.ami_id.map(item => <li>{item}</li>)
            }},
         minWidth: '125px',
         allowLineWrap: false
     }];

     return COLUMN_DEFINITIONS_FILTERS;
}

const paginationLabels = {
   nextPageLabel: 'Next page',
   previousPageLabel: 'Previous page',
   pageLabel: (pageNumber) => `Page ${pageNumber} of all pages`
 };


const COLUMN_DEFINITIONS_DETAILS = [
     {
         id: 'user_agent',
         header: () => 'User Agent',
         cell: (item) => item.user_agent,
         minWidth: '125px',
         allowLineWrap: false
     },
     {
         id: 'request_ts',
         header: () => 'Timestamp',
         cell: (item) => item.request_ts,
         minWidth: '100px',
         allowLineWrap: false
     },
     {
         id: 'identity_type',
         header: () => 'Identity Type',
         cell: (item) => item.identity_type,
         minWidth: '100px',
         allowLineWrap: false
     },
     {
         id: 'access_key',
         header: () => 'Access Keys',
         cell: (item) => item.access_key,
         minWidth: '100px',
         allowLineWrap: false
     },
     {
         id: 'region',
         header: () => 'Regions',
         cell: (item) => item.region,
         minWidth: '100px',
         allowLineWrap: false
     },
     {
         id: 'instance_type',
         header: () => 'Instance Types',
         cell: (item) => item.instance_type,
         minWidth: '100px',
         allowLineWrap: false
     },
     {
         id: 'ip_address',
         header: () => 'IP Addresses',
         cell: (item) => item.ip_address,
         minWidth: '100px',
         allowLineWrap: false
     },
     {
         id: 'ami_id',
         header: () => 'AMIs',
         cell: (item) => item.ami_id,
         minWidth: '100px',
         allowLineWrap: false
     }];
 
  export class SummariesTable extends React.Component {
     constructor(props) {
         super(props);
         this.state = {
             accountId: "NaN",
             searchAccountId: null,
             startDate: this.createDate(0, 0, -1),
             startTime: this.createTime(),
             endDate: this.createDate(0, 0, 0),
             endTime: this.createTime(),
             eventsSummary: [],
             eventsDetail: [],
             startTimeModalOpen: false,
             endTimeModalOpen: false,
             filterModalOpen: false,
             filterType: 'Any',
             filterCategories: [],
             filterModalCategory: '',
             filterModalValue: '',
             currentPageIndex: 1,
             pageSize: 10,
             pagesCount: 5,
             sortCategory: null,
             sortOrder: null,
             initialLoadDone: false,
             eventLoadDone: false
         };
         this.clientLoaded = this.clientLoaded.bind(this);
         this.getSummaryResultHandler = this.getSummaryResultHandler.bind(this);
         this.getEventsDetailResultHandler = this.getEventsDetailResultHandler.bind(this);
         this.numtoTime = this.numtoTime.bind(this);
         this.loadItems = this.loadItems.bind(this);
         this.createDate = this.createDate.bind(this);
         this.createTime = this.createTime.bind(this);
         this.hideFilterModal = this.hideFilterModal.bind(this);
         this.showFilterModal = this.showFilterModal.bind(this);
         this.hideStartTimeModal = this.hideStartTimeModal.bind(this);
         this.showStartTimeModal = this.showStartTimeModal.bind(this);
         this.hideEndTimeModal = this.hideEndTimeModal.bind(this);
         this.clearAllFilters = this.clearAllFilters.bind(this);
         this.removeFilter = this.removeFilter.bind(this);
         this.displayFilters = this.displayFilters.bind(this);
         this.updateRadioValue = this.updateRadioValue.bind(this);
         this.updateFilterModalCategory = this.updateFilterModalCategory.bind(this);
         this.updateFilterModalValue = this.updateFilterModalValue.bind(this);
         this.updateFilterCategories = this.updateFilterCategories.bind(this);
         this.updateFilterFromTable = this.updateFilterFromTable.bind(this);
         this.updateStartTime = this.updateStartTime.bind(this);
         this.updateStartDate = this.updateStartDate.bind(this);
         this.updateEndTime = this.updateEndTime.bind(this);
         this.updateEndDate = this.updateEndDate.bind(this);
         this.updateSearchAccountId = this.updateSearchAccountId.bind(this);
         this.applyStartTimeModal = this.applyStartTimeModal.bind(this);
         this.applyEndTimeModal = this.applyEndTimeModal.bind(this);
         this.onSortingChange = this.onSortingChange.bind(this);
         this.onPaginationChange = this.onPaginationChange.bind(this);
 }

     clientLoaded() {
        this.setState({ initialLoadDone: true });
        let start = this.state.startDate + " " + this.state.startTime;
        let end = this.state.endDate + " " + this.state.endTime;
        const startTime = Date.parse(start);
        const endTime = Date.parse(end);
        let resourcePath = `&filterType=${this.state.filterType}`;
        for (const filter of this.state.filterCategories) {
            resourcePath = resourcePath + `&${filter.category}=${filter.value}`;
        }
        this.client.getSummary(this.state.accountId, startTime, endTime, resourcePath, this.getSummaryResultHandler);
        this.client.getEventsDetail(this.state.accountId, startTime, endTime, this.state.pageSize, this.state.currentPageIndex,
         this.state.sortCategory, this.state.sortOrder, resourcePath, this.getEventsDetailResultHandler);
    }

    componentWillMount() {
        this.client = new JSClient();
        this.clientLoaded();
    }

    getSummaryResultHandler(eventResult) {
        let keys = Object.keys(eventResult);
        let values = Object.values(eventResult);
        let result =  values.reduce(function(result, field, index) {
          result[keys[index]] = field;
          return result;
        }, {})
        this.setState({  eventsSummary: [result] || [], eventLoadDone: true });
    }

    getEventsDetailResultHandler(eventResult) {
        this.numtoTime(true, eventResult.startTime);
        this.numtoTime(false, eventResult.endTime);
        this.setState({ eventsDetail: eventResult.events, accountId: eventResult.accountId, searchAccountId: eventResult.accountId,
        pagesCount: eventResult.limit, eventLoadDone: true });
    }

     numtoTime(startCheck, timeNum) {
        let date = new Date(timeNum);
        let strTime = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
        let strDate = date.getFullYear() + "/" + parseInt(date.getMonth()+1) + "/" + date.getDate();
        if (startCheck) {
            this.setState({startTime: strTime, startDate: strDate});
        } else {
            this.setState({endTime: strTime, endDate: strDate});
        }
     }

     loadItems() {
        try {
            let start = this.state.startDate + " " + this.state.startTime;
            let end = this.state.endDate + " " + this.state.endTime;
            const startTime = Date.parse(start);
            const endTime = Date.parse(end);
            let filtersPath = `&filterType=${this.state.filterType}`;
            for (const filter of this.state.filterCategories) {
                filtersPath = filtersPath + `&${filter.category}=${filter.value}`;
            }
            let accountId = null;
            if (this.state.searchAccountId == null || this.state.searchAccountId == "") {
                accountId = this.state.accountId;
            } else {
                accountId = this.state.searchAccountId;
            }
            this.client.getSummary(accountId, startTime, endTime, filtersPath, this.getSummaryResultHandler);
            this.client.getEventsDetail(accountId, startTime, endTime, this.state.pageSize, this.state.currentPageIndex,
            this.state.sortCategory, this.state.sortOrder, filtersPath, this.getEventsDetailResultHandler);
         } catch (e) {
             console.log(e);
             this.setState({eventLoadDone: false});
         }
     }

     createDate(days, months, years) {
        let date = new Date();
        date.setDate(date.getDate() + days);
        date.setMonth(date.getMonth() + months);
        date.setFullYear(date.getFullYear() + years);
        let strDate = date.getFullYear() + "/" + parseInt(date.getMonth()+1) + "/" + date.getDate();
        return strDate;    
    }

    createTime() {
        let time = new Date();
        let strTime = time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds();
        return strTime;
    }

     hideFilterModal() {
         this.setState({ filterModalOpen: false });
     }

     showFilterModal() {
        this.setState({ filterModalOpen: true});
     }

     hideStartTimeModal() {
         this.setState({ startTimeModalOpen: false });
     }

     showStartTimeModal() {
        this.setState({ startTimeModalOpen: true});
     }

     hideEndTimeModal() {
         this.setState({ endTimeModalOpen: false });
     }

     showEndTimeModal() {
        this.setState({ endTimeModalOpen: true});
     }

     clearAllFilters() {
      this.setState({
        filterType: 'Any',
        filterCategories: []
      });
      this.loadItems();
     }

     removeFilter(key, value) {
        const items = this.state.filterCategories.filter(item => item.category !== key || item.value !== value);
        this.setState({
            filterCategories: items
        });
        this.loadItems();
     }

     displayFilters() {
        if (this.state.filterCategories && this.state.filterCategories.length) {
            return this.state.filterCategories.map((item, key)=>
            <li key={item.category + "-" + item.value}>{item.category} = {item.value} <Button type="link" text="Remove" 
            onClick={this.removeFilter.bind(this, item.category, item.value)}></Button></li>);
        }
     }

     updateRadioValue(event) {
         this.setState({
             filterType: event.detail.value
         });
         this.loadItems();
     }

     updateFilterModalCategory(event) {
        this.setState({
            filterModalCategory: event.detail.selectedId
        });
     }

     updateFilterModalValue(event) {
        this.setState({
            filterModalValue: event.detail.value
        });
     }

     updateFilterCategories() {
        const category = this.state.filterModalCategory
        const value = this.state.filterModalValue
        let item = { category: category, value: value }
        this.setState({
            filterCategories: this.state.filterCategories.concat(item)
        });
        this.hideFilterModal();
        this.loadItems();
     }

     updateFilterFromTable(categoryToAdd, valueToAdd) {
        let item = {category: categoryToAdd, value: valueToAdd}
        this.setState({
            filterCategories: this.state.filterCategories.concat(item)
        });
        this.loadItems();
     }

     updateStartTime(event) {
        this.setState({
            startTime: event.detail.value
        });
     }

     applyStartTimeModal() {
        this.hideStartTimeModal();
        this.loadItems();
     }

     updateStartDate(event) {
        this.setState({
            startDate: event.detail.value
        })
     }

     updateEndTime(event) {
        this.setState({
            endTime: event.detail.value
        });
     }

     applyEndTimeModal() {
        this.hideEndTimeModal();
        this.loadItems();
     }

     updateEndDate(event) {
        this.setState({
            endDate: event.detail.value
        })
     }

     updateSearchAccountId(event) {
        this.setState({
            searchAccountId: event.detail.value
        })
     }

     onSortingChange(evt) {
        let order = null;
        if (evt.detail.sortingDescending) {
            order = "Descending";
        } else {
            order = "Ascending";
        }
         this.setState({
           sortCategory: evt.detail.sortingColumn,
           sortOrder: order
         });
         this.loadItems();
     }

     onPaginationChange(evt) {
          this.setState({
            pageSize: evt.detail.pageSize,
            currentPageIndex: evt.detail.currentPageIndex
          });
          this.loadItems();
     }


     render() {
        return(
            <div>
            <div className='awsui-grid awsui-util-p-s'>
                <div className='custom-home__header custom-awsui-util-pt-xxxl awsui-row'>
                  <div className='col-xxs-12'>
                <div><h1>RECORD - REaltime COmpRomise Detection</h1></div>
                <div><h2>Recent Suspicious EC2 Launch Requests for Account: {this.state.accountId}</h2></div>
                </div>
                </div>
                </div>
            <div className='custom-home__header-title col-xxs-10 col-s-4 col-l-5 col-xl-6'>
                <p>Search by account <Input type="search" placeholder="Enter Account ID" onChange={this.updateSearchAccountId.bind(this)}></Input></p>
                
                <Button variant="primary" text="Search" onClick={this.loadItems.bind(this)}></Button>
            </div>

                <p className='awsui-util-mb-s'>Time range of requests: {this.state.startDate} {this.state.startTime} - {this.state.endDate} {this.state.endTime}</p>
                <ColumnLayout columns={4} variant="text-grid">
                    <div data-awsui-column-layout-root="true">
                        <Button variant="normal" text="Edit start time" onClick={this.showStartTimeModal.bind(this)}></Button>
                            <Modal expandToFit={true} visible={this.state.startTimeModalOpen} header="Change the start time"
                            footer={<span className="awsui-util-f-r"> <Button variant="link" text="Close"
                             onClick={this.hideStartTimeModal.bind(this)}></Button>
                            <Button variant="primary" text="Edit" onClick={this.applyStartTimeModal.bind(this)}></Button> </span>} >
                            <DatePicker
                              placeholder="MM/DD/YYYY"
                              todayLabel="Today"
                              nextMonthLabel="Next month"
                              previousMonthLabel="Previous month"
                              onChange={this.updateStartDate.bind(this)}
                            ></DatePicker>
                            <TimeInput placeholder="hh:mm:ss" onChange={this.updateStartTime.bind(this)}></TimeInput>
                            </Modal>
                        <Button variant="normal" text="Edit end time" onClick={this.showEndTimeModal.bind(this)}></Button>
                            <Modal expandToFit={true} visible={this.state.endTimeModalOpen} header="Change the end time"
                            footer={<span className="awsui-util-f-r"> <Button variant="link" text="Close"
                             onClick={this.hideEndTimeModal.bind(this)}></Button>
                            <Button variant="primary" text="Edit" onClick={this.applyEndTimeModal.bind(this)}></Button> </span>} >
                            <DatePicker
                              placeholder="YYYY/MM/DD"
                              todayLabel="Today"
                              nextMonthLabel="Next month"
                              previousMonthLabel="Previous month"
                              onChange={this.updateEndDate.bind(this)}
                            ></DatePicker>
                            <TimeInput placeholder="hh:mm:ss" onChange={this.updateEndTime.bind(this)}></TimeInput>
                            </Modal>
                    </div>
                </ColumnLayout>

                <div className='awsui-util-mb-l'>
                    <div className='awsui-util-p-s'>
                        <Modal expandToFit={true} visible={this.state.filterModalOpen} header="Add a filter"
                        footer={<span className="awsui-util-f-r"> <Button variant="link" text="Close"
                         onClick={this.hideFilterModal.bind(this)}></Button>
                        <Button variant="primary" text="Apply" 
                            onClick={this.updateFilterCategories.bind(this)}>
                        </Button> </span>} >
                        <Select placeholder="Choose a category to filter by" options={CATEGORIES}
                         onChange={this.updateFilterModalCategory.bind(this)}></Select>
                        <span> <h5> Add filter below. </h5>
                        <Textarea placeholder="Enter here" onChange={this.updateFilterModalValue.bind(this)}></Textarea>
                         </span>
                     </Modal>
                    </div>

                    
                    <div className="awsui-util-container awsui-util-no-gutters">
                      <div>
                        <ColumnLayout
                          borders="horizontal"
                          className="awsui-util-no-gutters"
                        >
                          <div data-awsui-column-layout-root={true}>
                            <ColumnLayout
                              columns={2} variant="text-grid" className="awsui-util-ph-l awsui-util-pb-l awsui-util-pt-m">
                              <div data-awsui-column-layout-root="true">
                                <div>
                                  <div className="awsui-util-spacing-v-s">
                                    <div>
                                      <div className="awsui-util-label">
                                        Current Filters
                                      </div>
                                      <div>
                                        <ul>{this.displayFilters()}</ul>
                                        <Button variant="primary" text="Add a filter" onClick={this.showFilterModal.bind(this)}></Button>
                                        <Button onClick={this.clearAllFilters.bind(this)} text='Clear all filters'></Button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <div className="awsui-util-spacing-v-s">
                                    <div>
                                      <div className="awsui-util-label">
                                        Filter Type
                                      </div>
                                      <div>
                                        <RadioGroup value={this.state.filterType} items={FILTER_TYPES} onChange={this.updateRadioValue.bind(this)}></RadioGroup>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div> 
                            </ColumnLayout>
                            <div className="awsui-util-container-header">
                                <h2>Summaries Table</h2>
                            </div>
                            <Table
                              variant="borderless"
                              columnDefinitions={createColumnFilters(this.updateFilterFromTable.bind(this))}
                              items={this.state.eventsSummary}
                              loading={!this.state.eventLoadDone}
                              loadingText='Loading events'
                              empty={
                                   <div className='awsui-util-t-c'>
                                     <div className='awsui-util-pt-xs awsui-util-mb-xs'>
                                       <b>No matches</b>
                                     </div>
                                     <p className='awsui-util-mb-s'>We can't find a match.</p>
                                   </div>
                               }
                            >
                            </Table>
                            <div className="awsui-util-container-header">
                                <h2>Detail Table</h2>
                            </div>
                            <Table
                                columnDefinitions={COLUMN_DEFINITIONS_DETAILS}
                                items={this.state.eventsDetail}
                                loading={!this.state.eventLoadDone}
                                loadingText='Loading events'
                                empty={
                                    <div className='awsui-util-t-c'>
                                      <div className='awsui-util-pt-xs awsui-util-mb-xs'>
                                        <b>No matches</b>
                                      </div>
                                      <p className='awsui-util-mb-s'>We can't find a match</p>
                                    </div>
                                }
                              >
                              <TableSorting
                               sortingColumn={this.state.sortCategory}
                               sortableColumns={COLUMN_DEFINITIONS_DETAILS.map(def => ({id: def.id}))}
                               disabled={!this.state.eventLoadDone}
                               onSortingChange={this.onSortingChange.bind(this)}
                             />
                              <TablePagination
                                   labels={paginationLabels}
                                   currentPageIndex={this.state.currentPageIndex}
                                   pagesCount={this.state.pagesCount}
                                   onPaginationChange={this.onPaginationChange}
                                   disabled={!this.state.eventLoadDone}
                                   pageSize={this.state.pageSize}
                                 />
                            </Table>
                          </div>
                        </ColumnLayout>
                      </div>
                    </div>
                </div>
            </div>
            );
     }
 }



// WEBPACK FOOTER //
// ./src/components/summaries_table.jsx